











import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiCardDetailEntry from "../common/AsiCardDetailEntry.vue";
import AsiCardDetail from "../common/AsiCardDetail.vue";
import Order from "../../models/order/Order";
import {Icon} from "@/helpers/icons";
import OrderUpdateDialogAdditionalInfos from "@/components/order/OrderUpdateDialogAdditionalInfos.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {OrderUpdateDialogAdditionalInfos, AsiCardDetailEntry, AsiCardDetail}
})
export default class OrderCardAdditionalInfos extends Vue {

	@Prop({type: Object, required: true})
	public order!: Order;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	@Emit('orderChanged')
	public orderChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}
}
